import React from 'react';

const BackButton = ({navigate, path}) => (
        <button type="button" className="btn btn-info shadow"
                onClick={() => navigate(path)}>
            Indietro
        </button>
    );

export default BackButton;
